import React, { useState } from "react";
import DrawerAppBar from "../../../components/mobile/Navbar";
import { Stack } from "@mui/material";
import { Card } from "../Components/Card";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Total } from "../Components/Total";
import { ListReceipts } from "../../../../domain/usecases/list-receipts";
import { Receipt } from "../../../../domain/models/receipt-model";
import { useNavigate } from "react-router-dom";

type Props = {
  listReceipts: ListReceipts;
};

export const Check: React.FC<Props> = ({ listReceipts }) => {
  const [receipts, setReceipts] = useState<Receipt[]>([]);
  const navigate = useNavigate();

  return (
    <Stack>
      <DrawerAppBar
        title="Conferir Mercadorias"
        onBack={() => {
          navigate("/mobile/tasks");
        }}
      />
      <Total text="Total de Conferências" number="13" />
      <Stack sx={{ m: "20px" }}>
        <Card
          color="#E85CF6"
          text="Conferência de Entrada"
          number="1"
          icon={
            <ArrowForwardRoundedIcon fontSize="large" sx={{ color: "white" }} />
          }
          onClick={() => {
            navigate("/mobile/check/receipts", {
              replace: true,
            });
          }}
        />

        <Card
          color="#E85CF6"
          text="Conferência de Saída"
          number={receipts.length.toString()}
          icon={
            <ArrowBackRoundedIcon fontSize="large" sx={{ color: "white" }} />
          }
          onClick={() => {
            navigate("shipments");
          }}
        />
      </Stack>
    </Stack>
  );
};
